import MathUtil from "./MathUtil";
import { cloneDeep } from 'lodash';

export enum Direction {
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right"
}

class Utils {

  static anchorContainer(obj, anchor: PIXI.Point) {
    obj.pivot.set(obj.width * anchor.x, obj.height * anchor.y);
    obj.x = obj.x + obj.width * anchor.x;
    obj.y = obj.y + obj.height * anchor.y;
  }

  static sortSymbols(s1: PIXI.DisplayObject, s2: PIXI.DisplayObject, sortDir: { x?: string, y?: string }): number {
    let sortRes = 0;
    switch (sortDir.x) {
      case Direction.Left:
        switch (sortDir.y) {
          case Direction.Top:
            sortRes = Utils.sortByPositionLeftTop(s1, s2);
            break;
          default:
            sortRes = Utils.sortByPositionLeftBottom(s1, s2);
            break;
        }
        break;
      case Direction.Right:
        switch (sortDir.y) {
          case Direction.Top:
            sortRes = Utils.sortByPositionRightTop(s1, s2);
            break;
          default:
            sortRes = Utils.sortByPositionRightBottom(s1, s2);
            break;
        }
        break;
      default:
        sortRes = Utils.sortByPositionRightBottom(s1, s2);
        break;
    }

    return sortRes;
  }

  static sortByPositionRightBottom(s1: PIXI.DisplayObject, s2: PIXI.DisplayObject) {
    let sortRes = 0;
    if (s1.x > s2.x) {
      sortRes = 1;
    } else if (s1.x < s2.x) {
      sortRes = -1;
    } else if (s1.y > s2.y) {
      sortRes = 1;
    } else if (s1.y < s2.y) {
      sortRes = -1;
    }

    return sortRes;
  }

  static sortByPositionLeftBottom(s1: PIXI.DisplayObject, s2: PIXI.DisplayObject) {
    let sortRes = 0;
    if (s1.x < s2.x) {
      sortRes = 1;
    } else if (s1.x > s2.x) {
      sortRes = -1;
    } else if (s1.y > s2.y) {
      sortRes = 1;
    } else if (s1.y < s2.y) {
      sortRes = -1;
    }

    return sortRes;
  }

  static sortByPositionRightTop(s1: PIXI.DisplayObject, s2: PIXI.DisplayObject) {
    let sortRes = 0;
    if (s1.x > s2.x) {
      sortRes = 1;
    } else if (s1.x < s2.x) {
      sortRes = -1;
    } else if (s1.y < s2.y) {
      sortRes = 1;
    } else if (s1.y > s2.y) {
      sortRes = -1;
    }

    return sortRes;
  }


  static sortByPositionLeftTop(s1: PIXI.DisplayObject, s2: PIXI.DisplayObject) {
    let sortRes = 0;
    if (s1.x < s2.x) {
      sortRes = 1;
    } else if (s1.x > s2.x) {
      sortRes = -1;
    } else if (s1.y < s2.y) {
      sortRes = 1;
    } else if (s1.y > s2.y) {
      sortRes = -1;
    }

    return sortRes;
  }

  static parseStringifiedListOfNumbers(list: string): number[] {
    let result: number[] = [];

    let vals = list.split(",");
    vals.forEach((val) => {
      result.push(parseFloat(val));
    });
    return result;
  }

  static parseStringListToNumbersList(list: string[]): number[] {
    let result: number[] = [];

    list.forEach((val) => {
      let num = parseFloat(val);
      if (!isNaN(num)) {
        result.push(num);
      }
    });
    return result;
  }


  static addedToStage(display, callback, args = null, context = null) {
    console.error("MOVED TO APP.TS");
  }

  static calculateChance(percentChance: number): boolean {
    return Math.random() * 100 <= percentChance;
  }

  static spriteClone(obj: PIXI.Sprite): PIXI.Sprite {
    let s = new PIXI.Sprite(obj.texture);
    s.position = obj.position;
    s.scale = obj.scale;
    s.rotation = obj.rotation;
    s.anchor = obj.anchor;
    s.pivot = obj.pivot;
    return s;
  }

  static deepClone(obj: any): any {
    return cloneDeep(obj)
    // if (typeof obj !== "object" || obj === null) {
    //   return obj;
    // }
    // let result = Array.isArray(obj) ? [] : {};

    // for (let prop in obj) {
    //   result[prop] = Utils.deepClone(obj[prop]);
    // }
    // return result;
  }

  static getRandomEl(arr:any[]):any {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  static compareArrays(arr1: any[], arr2: any[]): boolean {
    if (arr1.length != arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (Array.isArray(arr1[i]) && Array.isArray(arr2[i])) {

        if (!Utils.compareArrays(arr1[i], arr2[i])) {
          return false;
        }
      } else if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;

  }

  static serialize(data, object) {
    if (!data) {
      return;
    }

    Object.keys(data).forEach((key) => {
      if (object.hasOwnProperty(key) && data[key] != undefined) {
        object[key] = data[key];
      }
    });
  }
}

export default Utils;
